import { createTheme } from "@mui/material";

export const theme = createTheme({
    typography: {
        fontFamily: [
            'Plus Jakarta Sans'
        ]
    }
})  